import * as React from "react";
import { CostOfCareCalculatorContext } from "./context/CostOfCareCalculatorState";

import { SuburbPriceChartComponent } from "./SuburbPriceChartComponent";
import { NearbySuburbsComponent } from "./NearbySuburbsComponent";

export const ResultsComponent = () => {

    const { state } = React.useContext(CostOfCareCalculatorContext)

    let minValue = state.suburbMin % Math.floor(state.suburbMin) > 0 ? state.suburbMin.toFixed(2) : state.suburbMin
    let maxValue = state.suburbMax % Math.floor(state.suburbMax) > 0 ? state.suburbMax.toFixed(2) : state.suburbMax
    let average = state.suburbAverage % Math.floor(state.suburbAverage) > 0 ? state.suburbAverage.toFixed(2) : state.suburbAverage

    return (
        <React.Fragment>
            <div className="flex flex-col md:flex-row gap-4 lg:gap-8 mb-8">
                <div className="w-full flex flex-col justify-between border border-skin-heading rounded-lg p-3 mb-4">
                    <div className="mb-2 text-11p sm:text-xs md:text-base-15">{state.suburbName.toUpperCase()} DAILY PRICE SPREAD</div>
                    <div className="mb-4 text-3xl font-bold text-skin-heading">${minValue} to ${maxValue}</div>
                    <div className="text-base-15 text-skin-grey">
                        Before subsidies
                        </div>
                </div>
                <div className="w-full flex flex-col justify-between border-skin-magenta border rounded-lg p-3 mb-4">
                    <div className="mb-2 text-11p sm:text-xs md:text-base-15">{state.suburbName.toUpperCase()} DAILY AVERAGE</div>
                    <div className="mb-4 text-3xl font-bold text-skin-autocomplete-mark">${average}</div>
                    <div className="text-base-15 text-skin-grey">
                        Before subsidies
                        </div>
                </div>
            </div>

            {state.showSuburbChart == true &&
                <div className="flex flex-col md:flex-row gap-4 lg:gap-8 mb-8 lg:mb-12">
                    <SuburbPriceChartComponent />
                    <NearbySuburbsComponent />
                </div>
            }

            {state.showSuburbChart == false &&
                <div className="w-full mx-auto md:w-3/5 xl:w-1/2 mb-8 lg:mb-12">
                    <NearbySuburbsComponent />
                </div>
            }
            
        </React.Fragment>
    );
}